import { render, staticRenderFns } from "./ProjectsGantt.vue?vue&type=template&id=5c2ec0b5&scoped=true&"
import script from "./ProjectsGantt.vue?vue&type=script&lang=js&"
export * from "./ProjectsGantt.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsGantt.vue?vue&type=style&index=0&id=5c2ec0b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2ec0b5",
  null
  
)

export default component.exports